module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "indicators-data",
    attrs: {
      "title": _vm.data.title
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.data.name))]), _vm._v(" "), (_vm.data.unit !== '%') ? _c('span', [_vm._v(_vm._s(_vm._f("dataformat")(_vm.data.value))), _c('i', [_vm._v(_vm._s(_vm.data.unit))])]) : _vm._e(), _vm._v(" "), (_vm.data.unit === '%') ? _c('span', [_vm._v(_vm._s(_vm._f("percentformat")(_vm.data.value))), _c('i', [_vm._v(_vm._s(_vm.data.unit))])]) : _vm._e(), _vm._v(" "), (_vm.data.compareInfo) ? _c('span', [_vm._v(_vm._s(_vm.data.compareInfo))]) : _vm._e(), _vm._v(" "), _c('span', {
    class: _vm.compare_color,
    attrs: {
      "title": "较上一周期"
    }
  }, [_vm._v(_vm._s(_vm.compare_format))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-644b3f48","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/components/indicators-data/IndicatorsData.vue
// module id = 637
// module chunks = 0